var websiteData = require('diy/util/websiteData');
/**
 * The regular expressions are created in JSController
 *
 * @returns {string|*|String|undefined}
 */
function getAppId() {
    var config = websiteData.getData('social'),
        appId = config.facebook.appId,
        hostedAppIds = config.facebook.hostedAppIds,
        host = window.location.host,
        re;
    for (var ix = 0; ix < hostedAppIds.length; ix++) {
        re = new RegExp(hostedAppIds[ix].jsRegexp);
        if (re.test(host)) {
            appId = hostedAppIds[ix].appId;
        }
    }

    return appId;
}

module.exports = getAppId;


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/FacebookAppId.js
 ** module id = 731
 ** module chunks = 0
 **/